import { getHomeDiscountData, getHomeGoodPriceData, getHomeHighScoreData, getHomeHotRecommendData, getHomeLongforData, getHomePlusData } from "@/lib/AtKit/services";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchHomeDataAction = createAsyncThunk("fetchdata", async (payload, { dispatch }) => {
  const goodPriceData = await getHomeGoodPriceData();
  dispatch(changeGoodPriceInfoAction(goodPriceData));

  const highScoreData = await getHomeHighScoreData();
  dispatch(changeHighScoreInfoAction(highScoreData));

  const discountData = await getHomeDiscountData();
  dispatch(changeDiscountInfoAction(discountData));

  const recommendData = await getHomeHotRecommendData();
  dispatch(changeRecommendInfoAction(recommendData));

  const longforData = await getHomeLongforData();
  dispatch(changeLongforInfoAction(longforData));

  const plusData = await getHomePlusData();
  dispatch(changePlusInfoAction(plusData));
});

const homeSlice = createSlice({
  name: "home",
  initialState: {
    goodPriceInfo: {},
    highScoreInfo: {},
    discountInfo: {},
    recommendInfo: {},
    longforInfo: {},
    plusInfo: {},
  },
  reducers: {
    changeGoodPriceInfoAction(state, { payload }) {
      state.goodPriceInfo = payload;
    },
    changeHighScoreInfoAction(state, { payload }) {
      state.highScoreInfo = payload;
    },
    changeDiscountInfoAction(state, { payload }) {
      state.discountInfo = payload;
    },
    changeRecommendInfoAction(state, { payload }) {
      state.recommendInfo = payload;
    },
    changeLongforInfoAction(state, { payload }) {
      state.longforInfo = payload;
    },
    changePlusInfoAction(state, { payload }) {
      state.plusInfo = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHomeDataAction.fulfilled, (state, action) => {
      // 这里不需要手动更新状态，因为fetchHomeDataAction已经处理了
    });
  },
});

export const { changeGoodPriceInfoAction, changeHighScoreInfoAction, changeDiscountInfoAction, changeRecommendInfoAction, changeLongforInfoAction, changePlusInfoAction } = homeSlice.actions;

export default homeSlice.reducer;
